import { render, staticRenderFns } from "./TerminalNumber.vue?vue&type=template&id=4537e72e"
import script from "./TerminalNumber.vue?vue&type=script&lang=js"
export * from "./TerminalNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports